import { connect } from "react-redux";

var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var LoadingButton = require("components/utility/LoadingButton");

@connect(
	(state, props) => ({}),
	(dispatch, props) => ({
		fetchUsers: (userIDs) => {
			return RosterActions.fetchUsersStoreless({
				query: { ids: userIDs.join(","), embed: "user.sso_data" }
			});
		},
		mergeStudents: (mapping) => {
			return RosterActions.mergeStudents({ mapping })
		}
	})
)

class MergeStudentsPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = { 
			idMapping: {},
			userLookup: {},
			mappingText: "",
			loading: false,
			complete: false
		}
	}
	
	onVerify() {
		this.setState({ loading: true });
		
		var mapping = {};
		
		this.state.mappingText.split("\n").forEach(row => {
			var parts = row.split(",").map(x => x.trim());
			if (parts.length === 2) {
				mapping[parts[0]] = parseInt(parts[1]);
			}
		})
		
		var userIDs = _.uniq(_.flatten(_.pairs(mapping)));

		this.props.fetchUsers(userIDs).then(response => {
			var lookup = {}
			response.users.forEach(x => {
				lookup[x.id] = x;
			})
			this.setState({
				idMapping: mapping,
				userLookup: lookup,
				mappingText: "",
				loading: false
			})
		})
	}
	
	onMerge() {
		this.setState({ loading: true })
		this.props.mergeStudents(this.state.idMapping).then(response => {
			this.setState({ complete: response.success })
		})
	}

	render() {
		if (this.state.complete) {
			var content = (
				<div>
					<p>Merged!</p>
				</div>
			);

		} else if (_.size(this.state.idMapping) === 0) {
			var content = (
				<div>
					<p>
						Enter in user IDs, separated by commas, with each pair on its
						own line. IDs on the left will have coins, SSO info, and writing
						data transferred to the IDs on the right. Left IDs will also
						be removed from active classes and suspended. IDs can be included
						multiple times on the right, but should only be on the left once.
					</p>
					<textarea className="form-control" rows={ 8 }
					 	value={ this.state.mappingText }
						placeholder={ "1001,2001\n3001,2001\n1002,2002" }
						onChange={ e => this.setState({ mappingText: e.target.value }) } />

					<br />
					<LoadingButton className="btn buttonPrimary"
						text="Verify Students"
						onClick={ this.onVerify } loading={ this.state.loading } />
				</div>
			)
		} else {
			var rows = _.map(this.state.idMapping, (toUserID, fromUserID) => {
				var toUser = this.state.userLookup[toUserID];
				var fromUser = this.state.userLookup[fromUserID];
				
				var toNameStyle = (toUser && toUser.suspended) ? { 'textDecoration': "line-through" } : {};
				var fromNameStyle = (fromUser && fromUser.suspended) ? { 'textDecoration': "line-through" } : {};

				return (
					<tr key={ toUserID + "-" + fromUserID }>
						<td>{ fromUserID }</td>
						<td style={ fromNameStyle }>{ fromUser ? fromUser.display_name : "" }</td>
						<td>{ fromUser ? fromUser.role : "" }</td>
						<td>{ fromUser ? _.keys(fromUser.sso_data).join(",") : "" }</td>
						<td>{ fromUser && fromUser.last_active ? $wr.formatDate(fromUser.last_active) : "" }</td>
						<td></td>
						<td>{ toUserID }</td>
						<td style={ toNameStyle }>{ toUser ? toUser.display_name : "" }</td>
						<td>{ toUser ? toUser.role : "" }</td>
						<td>{ toUser ? _.keys(toUser.sso_data).join(",") : "" }</td>
						<td>{ toUser && toUser.last_active ? $wr.formatDate(toUser.last_active) : "" }</td>
					</tr>
				);
			});
			var content = (
				<div>
					<p className="smallText">
						Students with names crossed out are suspended. Clever/Google will
						show if SSO is set. Last Active will be blank if students never
						logged on.
					</p>
					<table className="table table-striped table-bordered smallText">
						<tbody>
							<tr>
								<th colSpan={ 5 }>Remove Student</th>
								<th />
								<th colSpan={ 5 }>Keep Student</th>
							</tr>
							<tr>
								<th>ID</th>
								<th>Name</th>
								<th>Role</th>
								<th>SSO</th>
								<th>Last Active</th>
								<th />
								<th>ID</th>
								<th>Name</th>
								<th>Role</th>
								<th>SSO</th>
								<th>Last Active</th>
							</tr>
							{ rows }
						</tbody>
					</table>
										
					<LoadingButton className="btn buttonPrimary"
						text="Confirm and merge"
						onClick={ this.onMerge } loading={ this.state.loading } />
				</div>
			)
		}
		return (
			<div className="mergeStudentsPage container">
				<div className="headerSection">
					<header className="pageHeader">
						<h1>Merge Students</h1>
					</header>
					
					{ content }
				</div>
			</div>
		);
	}
};

MergeStudentsPage.WrappedComponent.propTypes = PageStrictPropTypes({
	fetchUsers: PropTypes.func.isRequired,
	mergeStudents: PropTypes.func.isRequired
});

module.exports = MergeStudentsPage;


// WEBPACK FOOTER //
// ./modules/components/appdev/wizards/MergeStudentsPage.js